import React, {useEffect, useState} from 'react';
import { getImages } from '../Const';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const TaskDetailsModal = ({ close, openEditTaskDetails, updateTask, updateLeadDataMultiple,noUpdateStage=false }) => {
    const handleSubmit = (e) => {
        e.preventDefault();

        //updateTask(leadData.id, leadData.tasks[index].id, value);

        updateTask(formData.lead_id, formData.schedule_id, formData.task_name, formData.task_completed == "yes", (formData.task_date.getMonth() + 1).toString().padStart(2, '0') + "/" + formData.task_date.getDate().toString().padStart(2, '0') + "/" + formData.task_date.getFullYear().toString().slice(-2),true);

        if(!noUpdateStage) {

            var values = {
                'id':formData.lead_id,
                'appraisal_stage':'InQueue',
                'lead_type':'EQR'
            }

            updateLeadDataMultiple(values);
        }

        close();
    }

    const [formData, setFormData] = useState({
        lead_id:openEditTaskDetails?.lead_id,
        schedule_id:openEditTaskDetails?.id,
        task_name:openEditTaskDetails?.text || '',
        task_completed:"no",
        task_date:openEditTaskDetails?.date
        ? new Date(`${openEditTaskDetails?.date}`) // becomes "2025/05/31"
        : new Date()
    });
    useEffect(() => {
        console.log(openEditTaskDetails);
        setFormData({
            lead_id:openEditTaskDetails?.lead_id,
            schedule_id:openEditTaskDetails?.id,
            task_name:openEditTaskDetails?.text || '',
            task_completed:"no",
            task_date:openEditTaskDetails?.date
            ? new Date(`${openEditTaskDetails?.date}`) // becomes "2025/05/31"
            : new Date()
        })
    },[openEditTaskDetails]);
    

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }

    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title" id="staticBackdropLabel">Task Details</h1>
                <button className="sm-box-close" type="button" onClick={close}>
                    <img src={getImages('close-anticon.png')} alt="Close" />
                </button>
            </div>
            <form className='begin-form follow-up-form sa-form' onSubmit={handleSubmit}>
                <div className="modal-body p-0">
                    <div className='pt-5 pb-4'>
                        <div className='sa-box mxw-520 mx-auto pt-4'>
                            <div className='form-group mb-4'>
                                <label>Task Name</label>                                
                                <input type="text" name="task_name" className='form-control' value={formData.task_name} onChange={onChangeInput}/>
                            </div>
                            <div className='form-group mb-4'>
                                {/*console.log("formData.task_completed", formData.task_completed)*/}
                                <div className='d-flex align-items-center'>
                                    <label className='me-4'>Task Completed</label>
                                    <div className='d-inline-block custom-radio me-4'>
                                        <input
                                            type="radio"
                                            id="dayModal_yes"
                                            name="task_completed"
                                            value="yes"
                                            className="form-check-input"
                                            checked={formData.task_completed == "yes"}
                                            onChange={onChangeInput}
                                        />
                                        <label htmlFor="dayModal_yes">Yes</label>
                                    </div>
                                    <div className='d-inline-block custom-radio'>
                                        <input
                                            type="radio"
                                            id="dayModal_no"
                                            name="task_completed"
                                            value="no"
                                            className="form-check-input"
                                            checked={formData.task_completed == "no"}
                                            onChange={onChangeInput}
                                        />
                                        <label htmlFor="dayModal_no">No</label>
                                    </div>

                                </div>
                            </div>
                            <div className='form-group mb-4'>
                                <div className='xs-title text-dblue mb-2'>Select Task Date</div>
                                <DatePicker
                                    selected={formData.task_date}
                                    onChange={(date) => setFormData({...formData,'task_date':date})}
                                    inline
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer text-center">
                        <button type='submit' className='blue-btn mx-auto'>Save</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default TaskDetailsModal